"use client"

import { Footer } from "@/components/Footer";
import { Header } from "@/components/Header";
import { AlaniBanner } from "@/components/AlaniBanner";
import { useEffect, useState } from "react";

export default function Layout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const [isBannerVisible, setIsBannerVisible] = useState(true);
  const [timerExecuted, setTimerExecuted] = useState(false);

  useEffect(() => {
    // Auto-hide banner after 5 seconds
    const timer = setTimeout(() => {
      setIsBannerVisible(false);
      setTimerExecuted(true);
    }, 5000); // 5 seconds

    const handleScroll = () => {
      // Only allow scroll-based hiding if timer hasn't executed yet
      if (!timerExecuted) {
        if (window.scrollY > 100) {
          setIsBannerVisible(false);
        } else {
          setIsBannerVisible(true);
        }
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      clearTimeout(timer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [timerExecuted]);

  return (
    <>
      <AlaniBanner isVisible={isBannerVisible} />
      <Header isBannerVisible={isBannerVisible} />
      <div className={isBannerVisible ? "pt-[64px] md:pt-[100px]" : "pt-[64px]"}>
        {children}
      </div>
      <Footer />
    </>
  );
}
